import React from 'react';
import { useIntl } from 'react-intl';
import { WebChatColorProps } from "@42maru/webchat";
import { WebchatColorPicker } from '../component';

import { WebchatColorFormProps } from '.';


const ChatWindowColorInputGroup: React.FC<WebchatColorFormProps> = (props) => {
    const { colors, legend, onChange } = props;

    const intl = useIntl();

    const onChangeColor = (color: string, key: keyof WebChatColorProps) => {
        onChange({ ...colors, [key]: color });
    };

    const onChangeColors = (color: string, keys: (keyof WebChatColorProps)[]) => {
        const colorClone = structuredClone(colors);
        keys.forEach(key => {
            (colorClone as any)[key] = color;
        });
        onChange(colorClone);
    };

    return (
        <fieldset className="webchat-setting-card-color-container">
            <legend className="sr-only">
                {legend}
            </legend>

            <fieldset className="color-setting-container">
                <legend className="field-label-bold">
                    {intl.formatMessage({ id: "b0054" })}
                </legend>
                <div className="color-setting-body">
                    <div className="color-setting-row">
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09052" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09052" })}
                                            colorKey="bubbleTextColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />

                        <div className="input-label">
                            {intl.formatMessage({ id: "b0022" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "b0022" })}
                                            colorKey="bubbleBackgroundColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />

                        <div className="input-label">
                            {intl.formatMessage({ id: "i09053" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09053" })}
                                            colorKey="bubbleBorderColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                    </div>
                </div>
            </fieldset>

            <fieldset className="color-setting-container">
                <legend className="field-label-bold">
                    {intl.formatMessage({ id: "i09060" })}
                </legend>
                <div className="color-setting-body">
                    <div className="color-setting-row">
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09061" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09061" })}
                                            colorKey="showMoreColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                    </div>
                    <div className="color-setting-row">
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09062" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09062" })}
                                            colorKey="popupButtonTextColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />

                        <div className="input-label">
                            {intl.formatMessage({ id: "i09063" })}
                        </div>

                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09063" })}
                                            colorKey="popupButtonBackgroundColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09064" })}
                        </div>

                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09064" })}
                                            colorKey="popupButtonBorderColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                    </div>
                </div>
            </fieldset>

            <fieldset className="color-setting-container">
                <legend className="field-label-bold">
                    {intl.formatMessage({ id: "i09054" })}
                </legend>
                <div className="color-setting-body">
                    <div className="color-setting-row">
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09052" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09052" })}
                                            colorKey="carouselTextColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />

                        <div className="input-label">
                            {intl.formatMessage({ id: "b0022" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "b0022" })}
                                            colorKey="carouselBackgroundColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />

                        <div className="input-label">
                            {intl.formatMessage({ id: "i09053" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09053" })}
                                            colorKey="carouselBorderColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                    </div>
                </div>
            </fieldset>

            <fieldset className="color-setting-container">
                <legend className="field-label-bold">
                    {intl.formatMessage({ id: "b0023" })}
                </legend>
                <div className="color-setting-body">
                    <div className="color-setting-row">
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09055" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09055" })}
                                            colorKey="carouselButtonTextColor"
                                            colors={colors}
                                            onChange={value => onChangeColors(value, ["carouselButtonTextColor", "suggestionButtonTextColor", "bubbleButtonTextColor"])}
                        />
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09056" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09056" })}
                                            colorKey="carouselButtonBackgroundColor"
                                            colors={colors}
                                            onChange={value => onChangeColors(value, ["carouselButtonBackgroundColor", "bubbleButtonBackgroundColor"])}
                        />
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09057" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09057" })}
                                            colorKey="carouselButtonBorderColor"
                                            colors={colors}
                                            onChange={value => onChangeColors(value, ["carouselButtonBorderColor", "bubbleButtonBorderColor"])}
                        />
                    </div>
                    <div className="color-setting-row">
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09058" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09058" })}
                                            colorKey="carouselButtonHoverColor"
                                            colors={colors}
                                            onChange={value => onChangeColors(value, ["carouselButtonHoverColor", "bubbleButtonHoverColor"])}
                        />
                    </div>
                </div>
            </fieldset>

            <fieldset className="color-setting-container">
                <legend className="field-label-bold">
                    {intl.formatMessage({ id: "i09065" })}
                </legend>
                <div className="color-setting-body">
                    <div className="color-setting-row">
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09052" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09052" })}
                                            colorKey="bubbleOddTextColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                        <div className="input-label">
                            {intl.formatMessage({ id: "b0022" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "b0022" })}
                                            colorKey="bubbleOddBackgroundColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09053" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09053" })}
                                            colorKey="bubbleOddBorderColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                    </div>
                </div>
            </fieldset>

            <fieldset className="color-setting-container">
                <legend className="field-label-bold">
                    {intl.formatMessage({ id: "i09036" })}
                </legend>
                <div className="color-setting-body">
                    <div className="color-setting-row">
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09050" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09050" })}
                                            colorKey="feedbackGoodButtonColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09051" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09051" })}
                                            colorKey="feedbackBadButtonColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                    </div>
                </div>
            </fieldset>

            <fieldset className="color-setting-container">
                <legend className="field-label-bold">
                    {intl.formatMessage({ id: "b0031" })}
                </legend>
                <div className="color-setting-body">
                    <div className="color-setting-row">
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09059" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09059" })}
                                            colorKey="carouselArrowColor"
                                            colors={colors}
                                            onChange={onChangeColor}
                        />
                    </div>
                </div>
            </fieldset>
        </fieldset>
    );
};

export default ChatWindowColorInputGroup;
